import participantPlugin from './participant';
import hyperlinkPlugin from './hyperlink';
import collapsePlugin from './collapse';
import cardPlugin from './card';
import tabsPlugin from './tabs';
import tableEditPlugin from './tableEdit';
import stepsPlugin from './steps';
import remoteComponent from './remoteComponent';

export {
  participantPlugin,
  hyperlinkPlugin,
  cardPlugin,
  collapsePlugin,
  tabsPlugin,
  tableEditPlugin,
  stepsPlugin,
  remoteComponent,
};

export default [participantPlugin, hyperlinkPlugin, cardPlugin, collapsePlugin, tabsPlugin, tableEditPlugin, stepsPlugin,remoteComponent];
